import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { IClient } from '../../models/client.model';
import * as clientSelector from '../../ngrx/reducers/client.reducer';

@Component({
  selector: 'loading',
  templateUrl: 'loading.html'
})
export class LoadingComponent {

  client$: Observable<IClient>;

  constructor(
    private store: Store<{}>
  ) { }

  ngOnInit() {
    this.client$ = this.store.select(clientSelector.getClient);
  }
}



// WEBPACK FOOTER //
// ./src/components/loading/loading.ts